import React, {useState} from "react";
import "./ForgotPassword.scss";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { forgetPassword } from "../../../store/auth/actions";
import Swal from "sweetalert2";

const ForgotPassword = (props) => {
  const [state, setState] = useState({
    email: "",
    loading: false
  });
  const handleForgetPassword = async (e) => {
    e.preventDefault();
    try{
      setState({...state, loading: true});
      const { email } = state;
      const { forgetPassword } = props;
      await forgetPassword({ email });
      Swal.fire("Please check your email to change your password", "", "success").then(()=>{
        setState({...state, email: ""})
      })
    }catch(err){
      Swal.fire("Incorrect email/password", "", "error")
    }finally{
      setState({...state, loading: false});
    }
  };
  return (
    <div className="ForgotPassword">
      <div className="left">
        <img src="/images/bg/forgot-password.png" alt="" className="img-fluid" />
      </div>
      <div className="right">
        <form action="" className="form" onSubmit={handleForgetPassword}>
          <div className="h1">Forgot Password</div>
          <div className="input-wrapper">
            <div className="input-top">
              <label htmlFor="" className="input-top-label">
                Email
              </label>
            </div>
            <input
              type="email"
              className="input form-control"
              placeholder="e.g. example@gmail.com"
              required
              value={state.email}
              onChange={(e)=>setState({...state, email: e.target.value})}
            />
          </div>

          <div className="input-wrapper">
            <input
              type="submit"
              value={state.loading ? "..." : "Send Email"}
              className="btn btn-primary rounded-3 btn-block btn-lg mt-4"
              disabled={state.loading}
            />
          </div>
          <div className="mt-3 text-center h5 text-muted w-100 ">
            Back to?{" "}
            <Link className="linked" to="/login">
              Log in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
});
export default connect(mapStateToProps, {
  forgetPassword
})(ForgotPassword);